import {useEffect, useState} from 'react'
import {TowelStatus, Towel} from '../types/towel.types'
import {getTowelsByStatus} from '../../../../services/towels.service'

export const useTowels = () => {
  const [towelsByStatus, setTowelsByStatus] = useState<Record<string, Towel[]>>({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadTowels()
  }, [])

  const loadTowels = async () => {
    try {
      const statuses: TowelStatus[] = ['disponible', 'en_uso', 'lavanderia', 'merma']

      const results: Record<string, Towel[]> = {}

      await Promise.all(
        statuses.map(async (status) => {
          const data = await getTowelsByStatus(status)
          results[status] = data || []
        })
      )

      setTowelsByStatus(results)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  return {
    towelsByStatus,
    loading,
    reload: loadTowels,
  }
}
